import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { twMerge } from 'tailwind-merge';

interface PanelProps {
  children: React.ReactNode;
  isFocused?: boolean;
  panelClassName?: string;
  focusedClassName?: string;
  title?: string;
  description?: string;
  extra?: React.ReactNode;
  isLoading?: boolean;
  dataTestId?: string;
}

const Panel = ({
  children,
  isFocused = false,
  panelClassName,
  focusedClassName,
  title,
  description,
  extra,
  isLoading,
  dataTestId,
}: PanelProps) => {
  const containerClassName = twMerge(
    'bg-kira-slate-0',
    'border-kira-slate-200',
    'border',
    'duration-200',
    'ease-in-out',
    'overflow-hidden',
    'p-6',
    'rounded-lg',
    'space-y-6',
    'transition-all',
    isFocused && 'ring-2 ring-kira-blue-800',
    isFocused && focusedClassName !== 'shadow-md' && 'drop-shadow-md',
    panelClassName,
    isFocused && focusedClassName
  );

  return (
    <div>
      {title && (
        <div className="flex justify-between pb-4 pl-6 pt-8">
          <div className="prose-title-h3 flex flex-col">
            {title}
            {description && (
              <div className="prose-body-sm-reg text-kira-slate-800">
                {description}
              </div>
            )}
          </div>
          {extra}
        </div>
      )}
      {isLoading ? (
        <Skeleton height={150} />
      ) : (
        <div className={containerClassName} data-testid={dataTestId}>
          {children}
        </div>
      )}
    </div>
  );
};

export default Panel;
